/**
 * Marque DoIt (canevas v0.5.0, `_marque`) : pastille sarcelle 28 px, rayon 7 px, « D » en Fraunces
 * blanc, suivie du mot « DoIt » en Fraunces 18 px. La pastille suit l'accent (`--color-brand`),
 * donc le thème ; le mark seul suffit quand la barre latérale est repliée (`wordmark={false}`).
 */
import type { JSX } from 'react'

export function Brand({ wordmark = true }: { wordmark?: boolean }): JSX.Element {
  return (
    <span className="flex items-center gap-2 px-2 py-1.5">
      <span aria-hidden="true"
            className="flex size-7 shrink-0 items-center justify-center rounded-[7px] bg-[var(--color-side-active)] font-display text-[15px] font-semibold text-[var(--color-side-active-text)]">
        D
      </span>
      {wordmark ? <span className="font-display text-lg font-semibold">DoIt</span> : null}
    </span>
  )
}
